export default "__VITE_ASSET__O6tqgO2c__"